import {
  AutomationHandler,
  useRegisterHandlerWithBroker
} from "components/automation/contexts/AutomationBrokerContext";
import { AutomationCommand } from "components/automation/types/automation";
import { ChartScreenshotPayload } from "components/automation/types/payloads";
import { CommandResult } from "components/automation/types/results";
import { Topic, Topics } from "components/automation/types/topics";

import { useScreenshotContext } from "./hooks";

export function ScreenshotAutomationHandler() {
  const { settings } = useScreenshotContext();

  const handler: AutomationHandler = {
    id: "screenshot-automation-handler",
    handles: function (topic: Topic): boolean {
      return (
        topic === Topics.GetChartScreenshotSettings ||
        topic === Topics.GetMapScreenshotSettings
      );
    },
    executeCommand: function (command: AutomationCommand): Promise<CommandResult> {
      if (
        command.topic === Topics.GetChartScreenshotSettings ||
        command.topic === Topics.GetMapScreenshotSettings
      ) {
        const resultPayload = {
          ...settings
        } as ChartScreenshotPayload;
        delete resultPayload.titleText;
        delete resultPayload.xAxisTitleText;
        delete resultPayload.yAxisTitleText;

        return Promise.resolve({
          status: "ok",
          payload: resultPayload
        });
      }
      return Promise.resolve({
        status: "ok"
      });
    }
  };
  useRegisterHandlerWithBroker(handler);

  return <></>;
}
